import styled from 'styled-components';
import { Tabs as MuiTabs } from '@material-ui/core';

export const Tabs = styled(MuiTabs)`
    .MuiTab-root {
        &.Mui-selected {
            font-weight: 700;
        }
        @media (min-width: ${({ theme }) =>
                `${theme.breakpoints.values['md']}px`}) {
            font-size: ${({ theme }) => theme.typography.body1.fontSize};
            padding: 12px 40px;
            max-width: 300px;
        }
    }
`;
